/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.29",
    versionName: "0.6.0-nightly.2026.8.29",
    versionChannel: "nightly",
    buildDate: "2026-08-29T00:14:55.203Z",
    commitHash: "f6da537a85bdaa8e9c1345ee0f1fd7fc28ddd835",
};
